import { format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

import { clock } from '@/services/clock';

import { getPeriodLabel } from '@/features/data-hub/lib/getPeriodLabel';
import { getTimeSince } from '@/shared/lib/date/getTimeSince';

type ExportDateSettings = {
  from: Date | string | null;
  to: Date | string | null;
};

type ExportDetailsLabelParams = {
  settings: ExportDateSettings;
  timezone: string;
  dateFormat: string;
  exportTimestamp?: number;
};

export const getExportDateLabel = ({
  settings,
  timezone,
  dateFormat,
  exportTimestamp
}: ExportDetailsLabelParams) => {
  const fromValue = settings.from;
  const toValue = settings.to;

  const date = exportTimestamp ? new Date(exportTimestamp) : clock.date();
  if (fromValue === 'all') {
    return 'All';
  }

  if (!fromValue) {
    return;
  }

  if (typeof fromValue === 'string') {
    const valuesMatch = /^([1-9]\d*)v$/.exec(fromValue);
    if (valuesMatch) {
      const valuesCount = Number.parseInt(valuesMatch[1], 10);
      return `Last ${valuesCount} ${getPeriodLabel('v', valuesCount)}`;
    }

    switch (fromValue.at(-1)) {
      case 'd':
        date.setDate(date.getDate() - Number.parseInt(fromValue.slice(0, -1), 10));
        break;
      case 'm':
        date.setMonth(date.getMonth() - Number.parseInt(fromValue.slice(0, -1), 10));
        break;
      case 'y':
        date.setFullYear(date.getFullYear() - Number.parseInt(fromValue.slice(0, -1), 10));
        break;
      default:
        break;
    }

    return `From ${format(toZonedTime(date, timezone), dateFormat)}`;
  }

  if (!toValue) {
    return;
  }

  return `${format(toZonedTime(fromValue, timezone), dateFormat)} - ${format(
    toZonedTime(toValue, timezone),
    dateFormat
  )}`;
};

export const getExportSinceLabel = (exportTimestamp?: number) => {
  if (!exportTimestamp) {
    return;
  }

  return getTimeSince(exportTimestamp);
};
